import "../cms.scss";
import Layout from "../../../layout";
import { useAppSelector } from "../../../hooks/store";
import { getCms } from "../../../reducers/generalSlice";

const PrivacyPolicy = () => {
  const getCmsData = useAppSelector(getCms);

  return (
    <Layout>
      <main>
        <section className="cms_sc ut_spc">
          <div className="conta_iner">
            <h1>Privacy Policy</h1>
            <h2>Introduction</h2>
            <div
              className={getCmsData ? "policy_txt" : "policy_txt2"}
              dangerouslySetInnerHTML={{
                __html: getCmsData
                  ? getCmsData?.privacyPolicy
                  : "No Data Found",
              }}
            />
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default PrivacyPolicy;
